import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { auth, profileAPI } from 'services';
import useUniversalStore from 'store/universalStore';
import { images } from 'assets/themes';
import { toast } from 'sonner';
import { identifyUser, trackEvent } from 'lib/analytics';

const LoginUsingUsername = () => {
    const navigate = useNavigate();
    const { user, write } = useUniversalStore((state) => state);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const notify = (type, message) => {
        if (type === "error") {
            toast.error(message);
        } else {
            toast.success(message);
        }
    }

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const { sessionToken } = await auth.loginUsingUsername(username, password);
            if (!sessionToken) {
                throw new Error("Login failed. Please check the username and password.");
            }

            const result = await auth.loginUsingSession(sessionToken);
            const { status, response: user } = result;
            if (status !== "success") {
                throw new Error("Login failed. Please try again.");
            }

            const basic = await profileAPI.getProfileBasics(user);
            const email = basic?.contact?.email;
            const businessName = basic?.business?.name;

            write({ user, userBasic: basic });

            identifyUser(user?.get("username"), {
                $first_name: businessName || user?.get("username"),
                $email: email,
                phone: user?.get("username")
            });
            trackEvent("Login");

            notify("success", "Login successful! Redirecting...");
            navigate("/", { replace: true });
        } catch (error) {
            notify("error", error?.message || "Login failed. Please check the username and password.");
        } finally {
            setLoading(false);
        }
    }

    if (user) return <Navigate to="/" />

    return (
        <div className="auth-container">
            <div className="auth-wrapper">
                <div className="auth-card">
                    <div className="auth-header">
                        <img src={images.logo} alt="Logo" className="auth-logo" />
                        <div className="auth-title">
                            <h1>Login Using</h1>
                            <h1 className="text-danger">Username</h1>
                        </div>
                    </div>

                    <form onSubmit={handleLogin} className="auth-form">
                        <input
                            type="text"
                            className="form-control mb-3"
                            placeholder="Enter Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                        <input
                            type="password"
                            className="form-control mb-3"
                            placeholder="Enter Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <button
                            type="submit"
                            disabled={!username || !password || loading}
                            className="btn btn-danger py-3"
                        >
                            {loading ? (
                                <span className="spinner-border spinner-border-sm me-2"></span>
                            ) : null}
                            {loading ? 'Please wait...' : 'Login'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default LoginUsingUsername
